import src from "IMAGE";
export default { src, width: 270, height: 210, blurWidth: 0, blurHeight: 0};
